export enum ConsentType {
    Necessary = 'cookie_cat_necessary',
    Functional = 'cookie_cat_functional',
    Statistic = 'cookie_cat_statistic',
    Marketing = 'cookie_cat_marketing',
    Unclassified = 'cookie_cat_unclassified'
}
